import StoreBadges from '../common/store_badges';

document.addEventListener('DOMContentLoaded', () => {
  const toggleBulkToolbar = () => {
    const toolbar = document.getElementById('store_notifications_bulk_toolbar');
    const checkedBoxes = document.querySelectorAll('.store_notification-id-check-box:checked');
    if (toolbar == null) {
      return;
    }
    if (checkedBoxes.length == 0) {
      toolbar.style.display = 'none';
    } else {
      toolbar.style.display = 'block';
    }
  };

  const indexDiv = document.getElementById('store_notifications_index') as HTMLElement;

  if (indexDiv == null) {
    return;
  }

  const checkBoxTds = indexDiv.querySelectorAll('td.check-box');
  checkBoxTds.forEach(checkBoxTd => {
    const checkbox = checkBoxTd.querySelector('input') as HTMLInputElement;
    checkBoxTd.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).tagName != 'INPUT') {
        checkbox.click();
      }
    });
  });

  const checkBoxThs = indexDiv.querySelectorAll('th.check-box');
  checkBoxThs.forEach(checkBoxTh => {
    const checkbox = checkBoxTh.querySelector('input') as HTMLInputElement;
    checkBoxTh.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).tagName != 'INPUT') {
        checkbox.click();
      }
    });
  });

  const copyLandingUrl = (e: MouseEvent) => {
    const button: HTMLButtonElement = e.target as HTMLButtonElement;
    const url = button.getAttribute('data-url');
    if (url == null) {
      return;
    }
    document.addEventListener(
      'copy',
      (e: ClipboardEvent) => {
        e.preventDefault();
        if (e.clipboardData == null) {
          return;
        }
        e.clipboardData.setData('text/plain', url);
      },
      {
        once: true,
      },
    );
    document.execCommand('copy');
    alert('共有用リンクをコピーしました');
  };

  // チェックボックスがクリックされるごとに実行
  const checkboxes = document.querySelectorAll('.store_notification-id-check-box');
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      toggleBulkToolbar();
    });
  });

  const allCheckBox = document.getElementById('all_check_for_store_notification_ids');
  if (allCheckBox == null) {
    return;
  }
  (allCheckBox as HTMLElement).addEventListener('change', () => {
    if ((allCheckBox as HTMLInputElement).checked) {
      checkboxes.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = true;
      });
    } else {
      checkboxes.forEach(checkbox => {
        (checkbox as HTMLInputElement).checked = false;
      });
    }
    toggleBulkToolbar();
  });

  const copyLandingUrlButtons = document.querySelectorAll('.copy-landing-url');
  copyLandingUrlButtons.forEach(button => {
    (button as HTMLButtonElement).addEventListener('click', e => {
      copyLandingUrl(e);
    });
  });

  const initialize = () => {
    toggleBulkToolbar();
    const storeBadgesClient = new StoreBadges();
    storeBadgesClient.initialize(indexDiv);
  }

  // 初期実行
  initialize();
});
